import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const METHODOLOGY_SPECIES_OBSERVATIONS =
  'https://www.thelandbankinggroup.com/science/indicators/species-observations-cf419';

export const ThreatenedSpeciesExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='threatened-species-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.details.threatenedSpecies.explainers.howDoMeasureThis.headline')}
        </ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              body={t('shared.ncaDetail.details.threatenedSpecies.explainers.howDoMeasureThis.threatenedSpeciesBody')}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_SPECIES_OBSERVATIONS} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
